import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContentText,
  Theme,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { PmiButton } from 'shell/components/shared/button';
import { PmiDialogContent } from 'shell/components/shared/dialog/content';
import { PmiDialogTitle } from 'shell/components/shared/dialog/title';

const useStyles = makeStyles((theme: Theme) => ({
  paper: { minWidth: '30rem', color: theme.palette.cdmBrand.main },
}));

interface EventInErrorWarningModalProps {
  id?: string;
  open: boolean;
  onClose: () => void;
  title?: string;
  message: string;
  onOk: () => void;
  onResubmit: () => void;
}

const EventInErrorWarningModal = ({
  id = 'error',
  open,
  message,
  title = 'Attenzione!',
  onClose,
  onOk,
  onResubmit,
}: EventInErrorWarningModalProps): React.ReactElement => {
  const classes = useStyles();

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <Dialog
      open={open}
      aria-labelledby={id}
      aria-describedby={id}
      classes={{ paper: classes.paper }}
      fullScreen={fullScreen}
    >
      <PmiDialogTitle id={`${id}-title`} color="white" backgroundColor="cdmBrand">
        {title}
      </PmiDialogTitle>
      <PmiDialogContent>
        <DialogContentText key={message} id={`${id}-content`} sx={{ whiteSpace: 'pre-line' }}>
          {message}
        </DialogContentText>
      </PmiDialogContent>
      <DialogActions>
        <PmiButton onClick={onOk} variant="outlined" color="primary">
          Segna OK
        </PmiButton>
        <PmiButton onClick={onResubmit} variant="outlined" color="primary">
          Reinoltra
        </PmiButton>
        <PmiButton onClick={onClose} variant="outlined" color="cdmBrand">
          Chiudi
        </PmiButton>
      </DialogActions>
    </Dialog>
  );
};

EventInErrorWarningModal.displayName = 'Event in error warning modal component';

export default EventInErrorWarningModal;
